<div class="header">
  <div class="logo">
    @if (logoUrl) {
      <img [src]="logoUrl" alt="IRIS" />
    }
  </div>
  <div class="navmenu">
    <!-- <div ngbDropdown class="d-inline-block">
      <button class="navitem" id="ngb-apps-menu" ngbDropdownToggle>
        <i class="gg-menu-grid-o"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="ngb-apps-menu">
        <div class="apps-menu">
          <a class="appitem" routerLink="/garnet">
            <ng-icon name="matTransformOutline" />
            Transform
          </a>
          <a class="appitem" routerLink="/taxpayer">
            <ng-icon name="matReceiptLongOutline" />
            E-Invois
          </a>
        </div>
      </div>
    </div> -->

    <div ngbDropdown class="d-inline-block">
      <button id="ngb-usermenu" class="navitem" ngbDropdownToggle>
        <!-- {{ store.user()?.username }} <i class="gg-chevron-down"></i> -->
        {{ store.selectedEntity()?.company }} <i class="gg-chevron-down"></i>
      </button>
      <div ngbDropdownMenu aria-labelledby="ngb-usermenu" class="dropmenu">
        <div class="dropitem group user-info">
          <div class="user-avatar">
            <span>{{ store.user()?.username?.slice(0, 2) }}</span>
          </div>
          <div class="user-details">
            <div class="tw-font-semibold">{{ store.user()?.username }}</div>
            <div class="help-text ellipsis">
              {{ store.user()?.email }}
            </div>
          </div>
        </div>
        <button
          class="dropitem group flex-apart tw-border-b"
          (click)="openModal(switchBusinessModal)"
        >
          <div class="tw-text-left">
            <h3 class="tw-font-semibold">{{ store.selectedEntity()?.company }}</h3>
            <p class="help-text">Business</p>
          </div>
          <!-- <ng-icon name="matUnfoldMoreOutline" size="16" /> -->
        </button>
        <!-- <div class="group">
          <a class="dropitem" routerLink="/account" target="_blank">
            <ng-icon name="matSettingsOutline" size="14" /> Settings
          </a>
          <a class="dropitem"><ng-icon name="matDevicesOutline" size="14" /> API Docs</a>
          <a class="dropitem">
            <ng-icon name="matPolicyOutline" size="14" /> Terms & Policies
          </a>
        </div> -->
        <button class="dropitem group tw-border-0" (click)="onLogoutClick()">
          <ng-icon name="matPowerSettingsNewOutline" /> Logout
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #switchBusinessModal>
  <div class="switch-account-modal tw-py-3 fixed-header">
    <div class="flex-apart tw-p-4">
      <h2>Switch Business</h2>
      <ng-icon name="matUnfoldMoreOutline" size="16" />
    </div>
    <div class="scrollable-list">
      @for (item of businessEntityList; track $index) {
        <button
          class="tw-p-4 tw-py-3 flex-apart switch-btn"
          [class]="{ active: item.companyid === activeEntity?.companyid }"
          (click)="switchBusiness(item)"
        >
          <!-- <h3 class="tw-font-semibold">{{ item.company }}</h3> -->
          <p class="tw-font-normal">{{ item.company }}</p>
          @if (item.companyid === activeEntity?.companyid) {
            <ng-icon name="matCheckOutline" size="20" />
          }
          <!-- <p class="help-text">{{ item.companyid }}</p> -->
        </button>
      }
    </div>
  </div>
</ng-template>
